import { FormikValues } from "formik";
import { Dropdown } from "primereact/dropdown";
import { useMemo } from "react";
import { getFormErrorMessage, isFormFieldValid } from "../../utils/formHelper";
import { classNames } from "primereact/utils";
import { InputNumber } from "primereact/inputnumber";
import { mapDefectEstimatedCosts } from "../../utils/defectTableHelper";

type Props = {
    disabled: boolean;
    formik: FormikValues;
    value: string;
}

export const FormEstimateDefectCost = (props: Props) => {
    const { disabled, formik, value } = props;

    const estimateDefectCostOptions = useMemo(() => (
        mapDefectEstimatedCosts()
    ), []);

    return (
        <div className="flex gap-2">
            <div className="field flex-1">
                <span className="p-float-label">
                    <Dropdown id={value} name={value} value={formik.values[value]} disabled={disabled} scrollHeight="400px"
                        onChange={formik.handleChange} options={estimateDefectCostOptions} className={classNames("w-full", { 'p-invalid': isFormFieldValid(value, formik) })} />
                        <label htmlFor={value} className={classNames({ 'p-error': isFormFieldValid(value, formik) })}>Select value</label>
                </span>
                {getFormErrorMessage(value, formik)}
            </div>
            <div className="field flex-1">
                <span className="p-float-label">
                    <InputNumber id="estimateDefectCost" name="estimateDefectCost" value={formik.values["estimateDefectCost"]} onValueChange={formik.handleChange} maxFractionDigits={2} minFractionDigits={2}
                        disabled={disabled || formik.values[value] !== 1} className={classNames("w-full", { 'p-invalid': isFormFieldValid("estimateDefectCost", formik) })} />
                    <label htmlFor={"estimateDefectCost"} className={classNames({ 'p-error': isFormFieldValid("estimateDefectCost", formik) })}>Custom value</label>
                </span>
                {getFormErrorMessage("estimateDefectCost", formik)}
            </div>
        </div>
    )
}
